/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"

const AdsterraBanner = ({ keyId, height, width, format = "iframe" }) => {
    const bannerRef = useRef(null)

    useEffect(() => {
        // https://www.highperformanceformat.com

        if (!bannerRef.current) return

        // Évite de charger plusieurs fois si le composant est remonté
        if (bannerRef.current.firstChild) return

        const configScript = document.createElement("script")
        configScript.type = "text/javascript"
        configScript.innerHTML = `
        atOptions = {
            'key' : '${keyId}',
            'format' : '${format}',
            'height' : ${height},
            'width' : ${width},
            'params' : {}
        };
    `

        const invokeScript = document.createElement("script")
        invokeScript.type = "text/javascript"
        invokeScript.src = `https://accuracyinstalled.com/${keyId}/invoke.js`

        bannerRef.current.appendChild(configScript)
        bannerRef.current.appendChild(invokeScript)

        // Optionnel : nettoyage si nécessaire
        return () => {
            const currentNode = bannerRef.current
            if (currentNode) {
                currentNode.innerHTML = ""
            }
        }
    }, [keyId, width, height, format])

    return (
        <div
            ref={bannerRef}
            style={{ textAlign: "center", margin: "10px 0" }} // Ajustez le style comme vous voulez
        ></div>
    )
}

export default AdsterraBanner
